import React from 'react';
import HomeIndemnityListSection from '../../SHARED/components/HomeIndemnityListSection';

const LAW_FIRM_INDEMNITY_COPY = {
  title: 'Pending Signatures',
  subtitle: 'Bonds with pending signed indemnity agreements',
  emptyList: 'No bonds with Pending Signatures.',
  view: 'View',
  markCompleted: 'Mark as completed',
};

const PendingSignaturesSection = ({
  missingIndemnityBonds,
  loadingIndemnity,
  markingIndemnity,
  getBondUrl,
  formatRelativeTime,
  handleMarkIndemnityClick,
}) => (
  <HomeIndemnityListSection
    copy={LAW_FIRM_INDEMNITY_COPY}
    bonds={missingIndemnityBonds}
    loadingIndemnity={loadingIndemnity}
    markingBondId={markingIndemnity}
    onMarkClick={handleMarkIndemnityClick}
    resolveBondUrl={(bond) => getBondUrl(bond.bond_type, bond.bond_id)}
    formatRelativeTimeFn={formatRelativeTime}
  />
);

export default PendingSignaturesSection;
